/*eslint-disable no-duplicate-imports */
import React, { useRef, useEffect } from 'react';
import { Modal, Row, Col, Container, Button } from 'react-bootstrap';
import './FilterModal.scss';
import PrimaryButton from '../button';
import { BackAvatarSVG } from '../../../img/GlobalSVG';
import { CLIENT_TYPES } from 'src/constants';
import { useSelector } from 'react-redux';
import GenericButton from '../../../../Components/GenericButton/GenericButton';

const FilterModal = ({
  showTitle = true,
  titleLabel = 'FILTERS',
  showClearFilter = false,
  showClearFilterLabel = 'RESET FILTER',
  showCancel = true,
  showCancelLabel = 'Cancel',
  showApply = true,
  showApplyLabel = 'Apply',
  showBackButton = true,
  showBackButtonMobile = true,
  applyFilterHandler,
  isVisible,
  customClasses,
  onHide,
  resetFilter,
  ...otherProps
}) => {
  const modalHeaderRef = useRef(null);
  const modalTitleRef = useRef(null);
  const modalContentRef = useRef(null);
  const modalFooterRef = useRef(null);

  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });

  useEffect(() => {
    if (isVisible) {
      modalTitleRef && modalTitleRef?.current?.focus();
      setTimeout(() => {
        modalHeaderRef &&
          modalHeaderRef?.current?.removeAttribute('aria-hidden');
        modalContentRef &&
          modalContentRef?.current?.removeAttribute('aria-hidden');
        modalFooterRef &&
          modalFooterRef?.current?.removeAttribute('aria-hidden');
      }, 1000);
    }
  }, [isVisible]);

  return (
    <>
      <Modal
        show={isVisible}
        onHide={onHide}
        className={`Right-Model member generic-model ${customClasses}`}
      >
        <Modal.Header closeButton>
          <Container className="px-0" aria-hidden={true} ref={modalHeaderRef}>
            <Row className="align-items-center p-0 m-0">
              {(showBackButton || (showBackButtonMobile && isMobileClient)) && (
                <Col className="px-0">
                  <Button
                    onClick={onHide}
                    className="back-arrow cursor-pointer d-inline"
                    variant="link"
                    aria-label="back"
                    role="button"
                    aria-hidden={true}
                  >
                    <BackAvatarSVG.BackArrowSVG />
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="align-items-center p-0 m-0">
              <Col className="px-0" ref={modalTitleRef} tabIndex={-1}>
                <Modal.Title>
                  {titleLabel}
                  <span className="sr-only">Panel Opened</span>
                </Modal.Title>
              </Col>
              {showClearFilter && (
                <Col>
                  <GenericButton
                    onClick={resetFilter}
                    variant="secondary"
                    className="ml-auto"
                  >
                    {showClearFilterLabel}
                  </GenericButton>
                </Col>
              )}
            </Row>
          </Container>
        </Modal.Header>
        <Modal.Body>
          <Container
            className="px-0 custom-scroller modal-content-container"
            aria-hidden={true}
            ref={modalContentRef}
          >
            {otherProps.children}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <div
            className="model-footer-btn txt-right p-0 m-0 border-0 d-flex"
            aria-hidden={true}
            ref={modalFooterRef}
          >
            <div>
              {showCancel && (
                //<button type="button" class="btn btn-link mr-2" onClick={onHide}>
                //{showCancelLabel}
                //</button>
                <GenericButton onClick={onHide} variant="link">
                  {showCancelLabel}
                </GenericButton>
              )}
            </div>
            <div>
              {showApply && (
                //<PrimaryButton variant="primary" onClick={applyFilterHandler}>
                //{showApplyLabel}
                //</PrimaryButton>
                <GenericButton onClick={applyFilterHandler} variant="primary">
                  {showApplyLabel}
                </GenericButton>
              )}
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FilterModal;
